import axios from 'axios';

const fetchSearchResults = async (
  { requestSkip,
    top,
    searchValue,
    curLang,
    selectedLang,
    selectedSearchMode,
    selectedSearchType,
    selectedSearchField,
    selectedFromDate,
    selectedToDate,
    highlightPreTag,
    highlightPostTag,
  }) => {
  try {
    let searchFields = '';
    let highlightFields = null;
    let filter = null;
    let searchMode = null;
    let queryType = null;
    let searchLang = selectedLang ? selectedLang : 'EN';
    searchLang = searchLang === 'CN' ? 'CH' : searchLang; 

    let searchVal = '';
    searchMode = "all";
    queryType = "full";

    if (selectedSearchMode && selectedSearchMode === 'fuzzy') {
      searchVal = searchValue ? `${searchValue}~` : '';
    } else if (selectedSearchMode && selectedSearchMode === 'startWith') {
      if (selectedSearchField === 'referenceNumber') {
        searchValue = searchValue ? searchValue.split('.').join('/./') : '';
      }
      searchVal = searchValue ? `/${searchValue}.*/` : '';
    } else if (selectedSearchMode && selectedSearchMode === 'endWith') {
      if (selectedSearchField === 'referenceNumber') {
        searchValue = searchValue ? searchValue.split('.').join('/./') : '';
      }
      searchVal = searchValue ? `/.*${searchValue}/` : ''
    } else if (selectedSearchMode && selectedSearchMode === 'contains') {
      searchVal = searchValue ? `${searchValue}~3` : ''
    } else {
      searchMode = null;
      queryType = null;
      searchVal = searchValue ? `${searchValue}` : ''
    }

    if (selectedSearchField === 'name') {
      searchFields = `scSanctionEntry/entry/languages/${searchLang}/identity/names/name/value`;
    } else if (selectedSearchField === 'POB') {
      searchFields = `scSanctionEntry/entry/languages/${searchLang}/identity/pobs`;
    } else if (selectedSearchField === 'address') {
      searchFields = `scSanctionEntry/entry/languages/${searchLang}/identity/addresses`;
    } else if (selectedSearchField === 'comment') {
      searchFields = `scSanctionEntry/entry/languages/${searchLang}/identity/comment`;
    } else if (selectedSearchField === 'biometric') {
      searchFields = `scSanctionEntry/entry/languages/${searchLang}/identity/biometricData/value`;
    } else if (selectedSearchField === 'referenceNumber') {
      searchFields = `scSanctionEntry/entry/languages/${searchLang}/referenceNumber`;
    } else if (selectedSearchField === 'additionInfo') {
      //Uncomment once index updated with below prop
      //searchFields = `scSanctionEntry/entry/languages/${searchLang}/addtlInfo`;
    } else if (selectedSearchField === 'listingReason') {
      //Uncomment once index updated with below prop
      //searchFields = `scSanctionEntry/entry/languages/${searchLang}/listngReason`;
    } else if (selectedSearchField === 'DOC') {
      searchFields = `scSanctionEntry/entry/languages/${searchLang}/identity/documents/docNumber,
                      scSanctionEntry/entry/languages/${searchLang}/identity/documents/docType1,
                      scSanctionEntry/entry/languages/${searchLang}/identity/documents/docType2`.replace(/\n\s+/g, '');
    } else if (selectedSearchField === 'all' || !selectedSearchField) {
      // Add once index updated with below prop
      //scSanctionEntry/entry/languages/${searchLang}/addtlInfo,
      //scSanctionEntry/entry/languages/${searchLang}/listngReason,
      searchFields = `scSanctionEntry/entry/languages/${searchLang}/identity/names/name/value,
                      scSanctionEntry/entry/languages/${searchLang}/identity/pobs,
                      scSanctionEntry/entry/languages/${searchLang}/identity/addresses,
                      scSanctionEntry/entry/languages/${searchLang}/identity/comment,
                      scSanctionEntry/entry/languages/${searchLang}/identity/biometricData/value,
                      scSanctionEntry/entry/languages/${searchLang}/referenceNumber,
                      scSanctionEntry/entry/languages/${searchLang}/identity/documents/docNumber,
                      scSanctionEntry/entry/languages/${searchLang}/identity/documents/docType1,
                      scSanctionEntry/entry/languages/${searchLang}/identity/documents/docType2,
                      scSanctionEntry/entry/languages/${searchLang}/identity/documents/note`.replace(/\n\s+/g, '');
    }


    if (selectedFromDate || selectedToDate) {
      if (selectedFromDate && selectedToDate) {
        const fromDate = selectedFromDate.replace(/-/g, '');
        const toDate = selectedToDate.replace(/-/g, '');
        filter = `scSanctionEntry/entry/languages/EN/identity/any( i : i/dobs/any(dob : ( dob/dateFrom ge '${fromDate}' and dob/dateFrom le '${toDate}') or (dob/dateFrom ge '${fromDate}' and dob/dateTo le '${toDate}')))`;
        const dobFields = `scSanctionEntry/entry/languages/${searchLang}/identity/dobs/dateFrom,scSanctionEntry/entry/languages/${searchLang}/identity/dobs/dateTo`;
        searchFields = searchFields ? `${searchFields},${dobFields}`.replace(/\n\s+/g, '') : `${dobFields}`.replace(/\n\s+/g, '');
      } else if (selectedFromDate && !selectedToDate) {
        const fromDate = selectedFromDate.replace(/-/g, '');
        filter = `scSanctionEntry/entry/languages/EN/identity/any( i : i/dobs/any(dob : dob/dateFrom ge '${fromDate}' ))`;
        const dobFields = `scSanctionEntry/entry/languages/${searchLang}/identity/dobs/dateFrom`;
        searchFields = searchFields ? `${searchFields},${dobFields}`.replace(/\n\s+/g, '') : `${dobFields}`.replace(/\n\s+/g, '');
      } else if (selectedToDate && !selectedFromDate) {
        const toDate = selectedToDate.replace(/-/g, '');
        filter = `scSanctionEntry/entry/languages/EN/identity/any( i : i/dobs/any(dob :  dob/dateFrom le '${toDate}' or dob/dateTo le '${toDate}'))`;
        const dobFields = searchFields + `scSanctionEntry/entry/languages/${searchLang}/identity/dobs/dateTo`;
        searchFields = searchFields ? `${searchFields},${dobFields}`.replace(/\n\s+/g, '') : `${dobFields}`.replace(/\n\s+/g, '');
      }
    }


    if(searchVal && (searchVal.includes('*') || searchVal.includes('?'))) queryType = "full"
    
    highlightFields = searchFields;
    filter = filter ? filter : '';
    let fuzzyFlag = false;
    if (selectedSearchMode && selectedSearchMode === 'fuzzy') {
      fuzzyFlag = true;
    }

    let headers = {};

    if (process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY) {
      headers = {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY,
      }
    } else {
      headers = {
        "Content-Type": "application/json",
      }
    }

    let requestBody = {
      search: searchVal,
      skip: requestSkip,
      top,
      searchFields: searchFields,
      filter,
      searchMode,
      queryType,
      highlight: highlightFields,
      highlightPreTag,
      highlightPostTag,
      count: true
    };
    if (!requestBody.filter || requestBody.filter === null) delete requestBody.filter;
    if (!requestBody.searchMode || requestBody.searchMode == null) delete requestBody.searchMode;
    if (!requestBody.queryType || requestBody.queryType == null) delete requestBody.queryType;
    //if(selectedSearchField === 'ALL' || !selectedSearchField) delete requestBody.highlight;
    let response = await axios.post(`${process.env.REACT_APP_SEARCH_URL}`, requestBody,
      { headers }
    );
    if (response && response.status === 200) {
      const { data: { value } } = response;
      const statsPayload = {
        search: searchValue,
        mode: selectedSearchMode,
        language: searchLang,
        field: selectedSearchField,
        time: new Date(),
        count: response.data['@odata.count'] || 0,
      }
      if (value && value.length > 0) {
        let numOfPaginationButtons = 0;
        let pageData = [];
        const numOfPaginations = Math.ceil(value.length / 10);
        console.log(numOfPaginations)
        if (0 < numOfPaginations < 1) {
          numOfPaginationButtons = numOfPaginations;
          pageData = value;
        } else {
          numOfPaginationButtons = numOfPaginations;
          pageData = value.slice(0, 10);
        }
        insertStatsEntry(statsPayload, pageData);
        return {
          pageData,
          data: value,
          numOfPaginationButtons,
          total: response.data['@odata.count'] || 0,
        }
      } else {
        insertStatsEntry(statsPayload, []);
        return {
          pageData: [],
          data: [],
          numOfPaginationButtons: 0,
          total: 0,
        }
      }

    }
  } catch (err) {
    console.log('Error')
  }
}


const insertStatsEntry = async (payload, response) => {
  if(response) {
    
    let topScore = 0;
    for(let res of response) {
       if(res && res['@search.score'] && res['@search.score'] > topScore) {
        topScore = res['@search.score'];
       }
    }
    payload.topscore = topScore && topScore > 0 ? (topScore.toFixed(2)).toString() : '0';

    let headers = {};

    if (process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY) {
      headers = {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY,
      }
    } else {
      headers = {
        "Content-Type": "application/json",
      }
    }
    try{
      await axios.post(`${process.env.REACT_APP_STATS_API}`, payload,
        { headers }
      );
    } catch(e) {
      console.log('Error while insert stats entry');
    }

  }
}

export { fetchSearchResults };
